/** Колір виділення ==текст== (прототип: #fde68a). */
export const MD_HIGHLIGHT = '#fde68a';
